namespace advisorop.components.advisor {
    
    export class AdvisorClientsController{
        $router;       
        public chartMarketValueByInvestor: domains.IChartDataSource;
        public chartMarketValueByHousehold: domains.IChartDataSource;
        showChart: boolean = false;
        selInvestorId: number = 0;
        adminMode: boolean = false;
        invListLoading: boolean = false;
        hhListLoading: boolean = false;
        invLoadingPanel: DevExpress.ui.dxLoadPanel;
        hhLoadingPanel: DevExpress.ui.dxLoadPanel;

        investorsLoadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#invList" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading Investors...",
            bindingOptions: {
                visible: "vm.invListLoading"
            },
            onInitialized: function (e: any) {
                this.invLoadingPanel = e.component;
            },
        };

        householdsLoadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#hhList" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading Households...",
            bindingOptions: {
                visible: "vm.hhListLoading"
            },
            onInitialized: function (e: any) {
                this.hhLoadingPanel = e.component;
            },
        };


        constructor(private identityService: services.IdentityService,
            private advisorService: services.AdvisorService, private $rootScope: ng.IRootScopeService) {            

            this.$rootScope.$on('adminModeChanged', (event: ng.IAngularEvent) => {
                this.adminMode = this.advisorService.isAdminModeEnabled();
            });

            this.chartMarketValueByInvestor = {
                chart: { caption: "", numberPrefix: "", subCaption: "Average Monthly Historical AUM", theme: "" },
                data: []
            };

            this.chartMarketValueByHousehold = {
                chart: { caption: "", numberPrefix: "", subCaption: "Average Monthly Historical AUM", theme: "" },
                data: []
            };    
        }

        showIndividualChart() {
            this.showChart = !this.showChart;
        };

        changeHousehold(id) {
            this.advisorService.getMarketValueByHousehold(id).then((response) => {
                //this.chartMarketValueByHousehold.data = [];
                this.chartMarketValueByHousehold = response.data;
            }).catch((response) => {
                toastr.error("Market data error: " + response.status + ":" + response.data);
            });
        };

        changeInvestor(id) {
            this.advisorService.getMarketValueByInvestor(id)
                .then(response => {
                    this.showChart = true;
                    this.chartMarketValueByInvestor = response.data;
                }, err => {
                    toastr.error("Market data error: " + err.status + ":" + err.data);
                });
        };

        investorsLoading(loading) {
            this.invListLoading = loading;
            // next line does not seem to trigger, this is not in scope here?
            this.hhLoadingPanel && this.hhLoadingPanel.repaint();
        };

        householdsLoading(loading) {
            this.hhListLoading = loading;
            // next line does not seem to trigger, this is not in scope here?
            this.invLoadingPanel && this.invLoadingPanel.repaint();
        };

        $onInit(): void {
            this.adminMode = this.advisorService.isAdminModeEnabled();                  
        }

        $routerOnActivate(next, previous) {            
        }        

    }



    class AdvisorClients implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = ["identityService", "advisorService", "$rootScope", AdvisorClientsController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/views/advisor-clients.html';            
        }
    }
    angular.module(Constants.APP).component("advisorClients", new AdvisorClients());
    
}